<template>
  <van-tabbar v-model="activeIndex" active-color="#117281" :fixed="isFixed" :class="{'fix-none' : !isFixed}" :before-change="beforeChange" @change="tabbarChange" >
    <van-tabbar-item to="/home-main">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? home.active : home.inactive" />
      </template>
    </van-tabbar-item>
<!--
    <van-tabbar-item replace to="/sort">
      <span>分类</span>
      <template #icon="props">
        <img :src="props.active ? sort.active : sort.inactive" />
      </template>
    </van-tabbar-item> -->
    <van-tabbar-item to="/gbb/qrCode/scan" v-if="showGbb">
      <span>GBB电瓶扫码</span>
      <template #icon="props">
        <img :src="props.active ? scan2.active : scan2.inactive" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/activity/2022/scan-first-half" v-if="!showGbb">
      <span>扫一扫</span>
      <template #icon="props">
        <img :src="props.active ? scan.active : scan.inactive" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/cart">
      <span>购物车</span>
      <template #icon="props">
        <img :src="props.active ? cart.active : cart.inactive" />
      </template>
    </van-tabbar-item>

    <van-tabbar-item to="/center" :badge="applyLength || ''">
      <span>我的</span>
      <template #icon="props">
        <img :src="props.active ? center.active : center.inactive" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { userUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import { commonUtils } from '@/utils/common'
export default {
  props: {
    active: {
      type: Number,
      default: 0
    },
    isFixed: {
      type: Boolean,
      default: true
    }
  },
  created () {
    this.activeIndex = this.active
    this.isWxEnv = commonUtils.isWxEnv()
    let u = navigator.userAgent
    this.isCZ = u.match(/czbu/i)
  },
  activated () {
    this.userInfo = userUtils.getClientInfo()
    console.log(this.userInfo)
    if (this.userInfo?.channelCode === '1210') {
      this.showGbb = true
    } else {
      this.showGbb = false
    }
    this.init()
  },
  data () {
    return {
      activeIndex: 0,
      home: {
        active: this.$getImgUrl('/wx-app-v2/img/home/tabs-home-active@2x.png'),
        inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-home@2x.png') // require('../views/img/home/tabs-home@2x.png')
      },
      // sort: {
      //   active: this.$getImgUrl( '/wx-app-v2/img/home/tabs-sort-active@2x.png') , // require('../views/img/home/tabs-sort-active@2x.png'),
      //   inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-sort@2x.png')  // require('../views/img/home/tabs-sort@2x.png')
      // },
      scan: {
        active: this.$getImgUrl('/wx-app-v2/img/home/tabs-scan-code-active@2x.png'), // require('../views/img/home/tabs-scan-code-active@2x.png'),
        inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-scan-code@2x.png') // require('../views/img/home/tabs-scan-code@2x.png')
      },
      scan2: {
        active: this.$getImgUrl('/wx-app-v2/img/home/tabs-scan-code-active@3x.png'), // require('../views/img/home/tabs-scan-code-active@2x.png'),
        inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-scan-code@3x.png') // require('../views/img/home/tabs-scan-code@2x.png')
      },
      cart: {
        active: this.$getImgUrl('/wx-app-v2/img/home/tabs-cart-active@2x.png'), // require('../views/img/home/tabs-cart-active@2x.png'),
        inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-cart@2x.png') // require('../views/img/home/tabs-cart@2x.png')
      },
      center: {
        active: this.$getImgUrl('/wx-app-v2/img/home/tabs-center-active@2x.png'), // require('../views/img/home/tabs-center-active@2x.png'),
        inactive: this.$getImgUrl('/wx-app-v2/img/home/tabs-center@2x.png') // require('../views/img/home/tabs-center@2x.png')
      },
      isWxEnv: false,
      isCZ: false,
      showGbb: false
    }
  },
  computed: {
    ...mapState({
      clientApplyList: state => state.user.clientApplyList,
      applyLength: state => state.user.applyLength
    })
  },

  mounted () {
    this.userInfo = userUtils.getClientInfo()
    console.log(this.userInfo)
    if (this.userInfo?.channelCode === '1210') {
      this.showGbb = true
    } else {
      this.showGbb = false
    }
  },

  methods: {
    tabbarChange (active) {
      if (active !== 0) {
        this.init()
      }
    },
    beforeChange (next) {
      if (next === 1 && !this.isWxEnv && !this.isCZ) {
        this.$emit('showWxDialog')
        return false
      } else {
        return true
      }
    },
    getApplyLength () {
      let params = {
        approveStatus: '01'
      }
      this.$store.dispatch('getClientApplyList', params).then(response => {})
    },
    init () {
      this.activeIndex = this.active
      let userLocal = userUtils.getUserLocal() || null
      let tokenExpireTime = (userLocal && userLocal.tokenExpireTime) || 0
      if (userLocal && tokenExpireTime) {
        let time = new Date().getTime()
        if (time < tokenExpireTime) {
          this.getApplyLength()
        } else {
          this.$store.commit('setClientApplyList', [])
          this.$store.commit('setApplyLength', 0)
        }
      } else {
        this.$store.commit('setClientApplyList', [])
        this.$store.commit('setApplyLength', 0)
      }
    }
  }
}
</script>

<style>
.fix-none{
  padding: 0.2rem 0rem;
  box-sizing: border-box;
}
</style>
